import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationDE from '../../locales/de/translation.json'
import translationEN from '../../locales/en/translation.json'

const resources = {
  de: {
    translation: translationDE,
  },
  en: {
    translation: translationEN,
  },
}

const supportedLngs = ['en', 'de']
const isBrowser = typeof window !== 'undefined'

// On client: use LanguageDetector to detect browser language
// On server: skip detector and use explicit language
if (isBrowser) {
  i18n.use(LanguageDetector)
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs,
    fallbackLng: 'en',
    // On server, default to English. On client, let detector handle it.
    lng: isBrowser ? undefined : 'en',

    detection: isBrowser ? { order: ['navigator', 'htmlTag'] } : undefined,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  })

export default i18n
